// src/api/config.ts
import axios from 'axios';


// Use environment variable for API URL if available, otherwise use default
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://inovdev.org/api' || 'http://localhost:5000';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://analytics.zandrigo.ai' || 'https://inovdev.org';
//const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 seconds timeout
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Clear token and redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
      return Promise.reject(new Error('Your session has expired. Please log in again.'));
    }
    
    // Handle 403 Forbidden errors
    if (error.response && error.response.status === 403) {
      window.location.href = '/unauthorized';
      return Promise.reject(new Error('You do not have permission to access this resource.'));
    }
    
    // Handle 404 Not Found
    if (error.response && error.response.status === 404) {
      return Promise.reject(new Error('The requested resource was not found.'));
    }
    
    // Handle 500 Server Error
    if (error.response && error.response.status >= 500) {
      return Promise.reject(new Error('A server error occurred. Please try again later.'));
    }
    
    // Handle network errors
    if (error.message === 'Network Error') {
      return Promise.reject(new Error('Unable to connect to the server. Please check your internet connection.'));
    }
    
    // Handle timeout
    if (error.code === 'ECONNABORTED') {
      return Promise.reject(new Error('The request timed out. Please try again.'));
    }
    
    // Default error handling
    return Promise.reject(error);
  }
);

export default api;
